var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-chip',{staticClass:"text-uppercase",attrs:{"text-color":"white","color":_vm.statusColor[_vm.activeStatus]},domProps:{"textContent":_vm._s(_vm.$tc(_vm.activeStatus))}})}
var staticRenderFns = []

export { render, staticRenderFns }